module.exports = __webpack_public_path__ + "static/media/logo_fiam.90d351bc.svg";